import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, LayoutGrid, Search, Heart, ShoppingBag } from 'lucide-react';
import { useStore } from '@/context/StoreContext';
import { cx } from '@/lib/format';

export const BottomNav = ({ onSearch }) => {
  const { cartCount, wishlist } = useStore();
  const base = 'flex flex-1 flex-col items-center justify-center gap-1 py-2 text-[10px] font-medium';
  const active = ({ isActive }) => cx(base, isActive ? 'text-[hsl(var(--primary))]' : 'text-muted-foreground');
  return (
    <nav
      data-testid="bottom-nav"
      className="fixed inset-x-0 bottom-0 z-40 flex border-t border-border bg-white/95 backdrop-blur pb-[env(safe-area-inset-bottom)] md:hidden"
    >
      <NavLink to="/" className={active} end><Home size={20} /> Home</NavLink>
      <NavLink to="/shop" className={active}><LayoutGrid size={20} /> Shop</NavLink>
      <button onClick={onSearch} className={cx(base, 'text-muted-foreground')} data-testid="bottom-nav-search"><Search size={20} /> Search</button>
      <NavLink to="/wishlist" className={active}>
        <span className="relative"><Heart size={20} />{wishlist.length > 0 && <span className="absolute -right-2 -top-1 grid h-4 w-4 place-items-center rounded-full bg-[hsl(var(--gaze-gold))] text-[9px] font-bold text-black">{wishlist.length}</span>}</span> Wishlist
      </NavLink>
      <NavLink to="/cart" className={active}>
        <span className="relative"><ShoppingBag size={20} />{cartCount > 0 && <span className="absolute -right-2 -top-1 grid h-4 w-4 place-items-center rounded-full bg-[hsl(var(--gaze-gold))] text-[9px] font-bold text-black">{cartCount}</span>}</span> Cart
      </NavLink>
    </nav>
  );
};

export default BottomNav;
